// Unpublished Work © 2022 Deere & Company

import {RESET_DBS_CUSTOMER_PROFILE, SET_DBS_CUSTOMER_PROFILE_DATA} from '../../action-list';
import {DbsCustomer} from '../../state/struct/dbs-customer-profile/dbs-customer';

const setProfileData = (state, action) => new DbsCustomer(action.dbsCustomerProfile.customer);

const resetCustomerProfile = () => new DbsCustomer({});

export function dbsCustomer(state = new DbsCustomer({}), action = {}) {
    const actionHandlers = {
        [RESET_DBS_CUSTOMER_PROFILE]: resetCustomerProfile,
        [SET_DBS_CUSTOMER_PROFILE_DATA]: setProfileData
    };

    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
}
